import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import { history } from '@@/core/history';
import type {
  ChangeAction,
  OnChange_step4_resourceCover_Action,
  OnChange_step4_resourceLabels_Action,
  OnClick_step4_preBtn_Action,
  Step4_Post_UpdateSetting_Action,
  OnClick_step4_submitBtn_Action,
} from './types';

export const step4Effects = {
  *onChange_step4_resourceCover(
    { payload }: OnChange_step4_resourceCover_Action,
    { select, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_resourceCover: payload.value,
        step4_dataIsDirty_count: collectionCreatorPage.step4_dataIsDirty_count + 1,
      },
    });
  },
  *onChange_step4_resourceLabels(
    { payload }: OnChange_step4_resourceLabels_Action,
    { select, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_resourceLabels: payload.value,
        step4_dataIsDirty_count: collectionCreatorPage.step4_dataIsDirty_count + 1,
      },
    });
  },
  *onClick_step4_preBtn({}: OnClick_step4_preBtn_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step: 3,
      },
    });
  },
  *step4_Post_UpdateSetting(
    action: Step4_Post_UpdateSetting_Action,
    { select, call }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    const params = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      status: collectionCreatorPage.step4_updateSetting.automatic ? 1 : 0,
      conditionType: collectionCreatorPage.step4_updateSetting.conditionType === 'every' ? 1 : 2,
      filterConditions: collectionCreatorPage.step4_updateSetting.conditions.map((c) => {
        return {
          key: c.key,
          limitOperatorType: c.limitOperatorType,
          value: c.limitOperatorType === 'STARTS_WITH' ? c.value : c.value,
        };
      }),
    };

    yield call(FServiceAPI.Resource.setCollectRules, params);
  },
  *onClick_step4_submitBtn(
    {}: OnClick_step4_submitBtn_Action,
    { select, call, put }: EffectsCommandMap,
  ) {
    const { collectionCreatorPage }: ConnectState = yield select(
      ({ collectionCreatorPage }: ConnectState) => ({
        collectionCreatorPage,
      }),
    );

    const params = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      tags: collectionCreatorPage.step4_resourceLabels,
      coverImages:
        collectionCreatorPage.step4_resourceCover !== ''
          ? [collectionCreatorPage.step4_resourceCover]
          : undefined,
      intro: collectionCreatorPage.step4_resourceIntroduction,
    };
    const {
      ret: ret_0,
      errCode: errCode_0,
      msg: msg_0,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.update, params);

    const params1 = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      // @ts-ignore
      serializeStatus: collectionCreatorPage.step4_updateSetting.isFinish ? 1 : 0,
      status: collectionCreatorPage.step4_updateSetting.automatic ? 1 : 0,
      conditionType: collectionCreatorPage.step4_updateSetting.conditionType === 'every' ? 1 : 2,
      filterConditions: collectionCreatorPage.step4_updateSetting.conditions.map((c) => {
        return {
          key: c.key,
          limitOperatorType: c.limitOperatorType,
          value: c.value,
        };
      }),
    };

    const {
      ret: ret_1,
      errCode: errCode_1,
      msg: msg_1,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.setCollectRules, params1);

    const params2 = {
      resourceId: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
      status: 1,
    };
    const {
      ret: ret_2,
      errCode: errCode_2,
      msg: msg_2,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: any;
    } = yield call(FServiceAPI.Resource.update, params2);

    if (
      ret_0 !== 0 ||
      errCode_0 !== 0 ||
      ret_1 !== 0 ||
      errCode_1 !== 0 ||
      ret_2 !== 0 ||
      errCode_2 !== 0
    ) {
      if (ret_0 !== 0 || errCode_0 !== 0) {
        fMessage(msg_0, 'error');
      }

      if (ret_1 !== 0 || errCode_1 !== 0) {
        fMessage(msg_0, 'error');
      }

      if (ret_2 !== 0 || errCode_2 !== 0) {
        fMessage(msg_2, 'error');
      }
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        step4_dataIsDirty_count: 0,
      },
    });
    setTimeout(() => {
      history.replace(
        FUtil.LinkTo.collectionCreateSuccess({
          collectionID: collectionCreatorPage.step1_createdResourceInfo?.resourceID || '',
        }),
      );
    }, 100);
  },
};
